module.exports = __webpack_public_path__ + "static/img/m_name.8dd3bef.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/tsz/m_name.png
// module id = Zo4D
// module chunks = 7